import { DOCS_FORM_NAMES } from "core/consts";
import { FormFieldConfigFactory } from "../..";
import { createAccidentSurgeryDischargeLetterPdf } from "./pdfCreator";
import { DischargeLetterAccidentSurgeryFormSchema } from "./schema";
import { DischargeLetterAccidentSurgeryFormSections } from "./sections";

export const getDischargeLetterAccidentSurgeryFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_TRAUMA_SURGERY
> = () => {
  return {
    config: { canPrint: false, canSendToHis: true },
    getInitialValue: ({ value }) => ({
      admission_findings: value?.admission_findings ?? "",
      allergies: value?.allergies ?? "",
      anamnesis: value?.anamnesis ?? "",
      appointments: value?.appointments ?? "",
      clinical_course: value?.clinical_course ?? "",
      diagnoses: value?.diagnoses ?? "",
      discharge_recommendations: value?.discharge_recommendations ?? "",
      ecg: value?.ecg ?? "",
      further_findings: value?.further_findings ?? "",
      lab_results: value?.lab_results ?? "",
      medication_upon_discharge: value?.medication_upon_discharge ?? "",
      parameters: value?.parameters ?? "",
      social_anamnesis: value?.social_anamnesis ?? "",
      therapy: value?.therapy ?? "",
    }),
    header: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery.title,
    pdfConfig: {
      downloadPdfFileName: (translations) =>
        translations.extractDocs.dischargeLetter.generatedPdf
          .savedFileNameTraumSurgery,
      pdfCreator: createAccidentSurgeryDischargeLetterPdf,
    },
    schema: DischargeLetterAccidentSurgeryFormSchema,
    sections: DischargeLetterAccidentSurgeryFormSections,
  };
};
